<template lang="pug">
  .accounts-edit__container
    .account-edit-handler__container(v-for="(accounts, handler) in handlerAccounts" :key="`handler-${handler}-accounts`")
      .account-edit-handler__title {{ handler }}
      .accounts__container(v-if="chosenAccountsLoaded")
        el-checkbox-group(v-model="chosenAccounts[handler]" size="mini")
          el-checkbox-button(v-for="account in accounts" :label="account" :key="`handler-${handler}-accounts-${account}`") {{ account }}
    .control-bts__container
      el-button(type="success" size="mini" @click="startEditExchangeAccounts()") Сохранить
      el-button(type="danger" size="mini" @click="resetEditExchangeAccounts()") Отменить
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EDIT_EXCHANGE_HANDLERS_ACCOUNTS } from "@/store/const/exchanges";
import instruments from "@/mixins/instruments";

export default {
  name: 'EditExchangeAccounts',
  props: {
    exchange: { type: Object, default: () => {} },
  },
  mixins: [
    instruments,
  ],
  data() {
    return {
      chosenAccounts: {
        finex: [],
        saudi: [],
        emirates: [],
        bridge: [],
        honey: [],
      },
      chosenAccountsLoaded: false,
    }
  },
  mounted() {
    this.loadExchangeChosenAccounts();
  },
  computed: {
    ...mapGetters('handlers', [
      'handlerAccounts',
    ]),
  },
  methods: {
    ...mapActions('exchanges', {
      editExchangeAccounts: EDIT_EXCHANGE_HANDLERS_ACCOUNTS,
    }),
    loadExchangeChosenAccounts() {
      const result = {};
      for (const account of this.exchange.handler_accounts) {
        if (!result[account.handler]) {
          result[account.handler] = [];
        }
        result[account.handler].push(account.name);
      }
      this.chosenAccounts = { ...this.chosenAccounts, ...result };
      this.chosenAccountsLoaded = true;
    },
    async startEditExchangeAccounts() {
      this.$confirm('Вы действительно хотите изменить список аккаунтов?', 'Подтверждение').then(async () => {
        const accounts = [];
        for (const handler in this.chosenAccounts) {
          for (const name of this.chosenAccounts[handler]) {
            accounts.push({ handler, name });
          }
        }
        const request = await this.editExchangeAccounts({ id: this.exchange._id, accounts });
        if (request.success) {
          this.$message.success('Изменение успешно');
          this.resetEditExchangeAccounts();
        } else {
          this.$message.error(`Ошибка в изменении аккаунтов: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение отменено');
      });
    },
    resetEditExchangeAccounts() {
      this.$emit('resetExchangeAccountsEditing');
    }
  }
};
</script>
<style scoped>
.account-edit-handler__container {
    padding: 4px;
    border: 1px solid #cfcfcf;
    border-radius: 4px;
    margin-bottom: 8px;
}

.account-edit-handler__title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
}

.control-bts__container {
    margin-top: 5px;
}
</style>
